<template>
	<div class="container">
		<div class="main">
			<div class="content">
				<!--推荐圈子-->
				<circleRecommend :item="circleModel"/>
				
				<!--圈子列表-->
				<div class="content-inner">
					<!-- <div class="sort-wrap">
						<span :class="[sortType==0?'active':'']" @click="toChangeSort(0)">新互动</span>
						<span :class="[sortType==1?'active':'']" @click="toChangeSort(1)">最新</span>
						<span :class="[sortType==2?'active':'']" @click="toChangeSort(2)">热门</span>
					</div> -->
					<el-tabs class="tabs" v-model="activeTab" @tab-click="handleClick">
						<el-tab-pane name="all">
							<span slot="label">
								<el-select v-model="value" @change="toChangeSort" @focus="focus" placeholder="" class="lable-select">
									<el-option
										v-for="item in options"
										:key="item.value"
										:label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</span>
							<!--推荐新闻-->
							<circleNews v-if="topPost.length>0" :item="circleModel"/>
							<div class="scroll-container">
								<div v-show="dataList.length>0" 
										ref="scrollContainer"
										class="infinite-list"
										v-infinite-scroll="getDataList"
										>
									<div v-for="(item,index) in dataList" :key="index">
										<!-- 回答类型--> 
										<questions v-if="item.categoryScene == 'QUESTION'" :item="item" :type="item.categoryScene" @toGetList="getListDataAgain"/>
										<!-- 建议类型 -->
										<suggestion v-else-if="item.categoryScene == 'SUGGEST'" :item="item" :type="item.categoryScene" @toGetList="getListDataAgain"/>
										<!-- 其他普通类型 -->
										<articleCard v-else :item="item" :type="item.categoryScene" @getComment="getListDataAgain"/>	
									</div>
									<div v-if="loading" class="loading-text">加载中...</div>
									<div v-if="noMore" class="no-more-text">没有更多数据了</div>
								</div>
								<Empty content="该分类下无数据" v-show="dataList.length<1"/>
							</div>
							
						</el-tab-pane>
						<el-tab-pane v-for="(item,index) in navList"  :key="index" :label="item.categoryName" :name="item.id+''">
							<div>
								<div class="questions-wrap-inner" 
								:style="tabHasHorizontalScroll ? 'padding: 0 20px' : ''">
									<!-- 建议、反馈类型 的选择 -->
									<div class="suggestion-wrap" v-if="item.categoryScene == 'SUGGEST' || item.categoryScene == 'FEEDBACK'" >
										<!-- 建议 -->
										<el-select v-model="suggestStatus" clearable @change="toChangeSortJ" class="info-select" v-if="item.categoryScene == 'SUGGEST'">
											<el-option
												v-for="item in optionsStatusJ"
												:key="item.value"
												:label="item.label"
												:value="item.value">
											</el-option>
										</el-select>
										<!--反馈 -->
										<el-select v-model="feedbackStatus" clearable @change="toChangeSortF" class="info-select" v-if="item.categoryScene == 'FEEDBACK'">
											<el-option
												v-for="item in optionsStatusF"
												:key="item.value"
												:label="item.label"
												:value="item.value">
											</el-option>
										</el-select>
										<el-select v-model="sortType" @change="toQuestionSort(sortType)" placeholder="" class="info-select ml-1 width-s" v-if="item.categoryScene == 'SUGGEST' || item.categoryScene == 'FEEDBACK'">
											<el-option
												label="最新"
												:value="1">
											</el-option>
											<el-option
												label="热门"
												:value="2">
											</el-option>
										</el-select>
									</div>
									<!-- <el-select v-model="sysVersion" clearable @change="toChangeSys" placeholder="系统版本" class="info-select" v-if="item.categoryScene == 'SUGGEST' || item.categoryScene == 'FEEDBACK'">
										<el-option
											v-for="item in optionsStatusF"
											:key="item.value"
											:label="item.label"
											:value="item.value">
										</el-option>
									</el-select> -->
									<!-- 回答、建议、反馈类型 的选择 21  22 -->
									<!-- || item.categoryScene == 'QUESTION'|| item.categoryScene == 'FEEDBACK' -->
									<!-- <div class="questions-wrap" v-if="item.categoryScene == 'SUGGEST'">
										<span :class="[sortType==1?'active':'']" @click="toQuestionSort(1)">最新</span>
										<span :class="[sortType==2?'active':'']" @click="toQuestionSort(2)">热门</span>
									</div> -->
								</div>
								<div v-show="dataList.length>0" 	
									ref="scrollContainer"
									class="infinite-list"
									v-infinite-scroll="getDataList"
								>
									<div v-for="(i,_index) in dataList"  :key="_index">
										<!-- 回答类型--> 
										<questions v-if="item.categoryScene == 'QUESTION'" :item="i" :type="item.categoryScene" @toGetList="getListDataAgain"/>
										<!-- 建议类型 -->
										<suggestion v-else-if="item.categoryScene == 'SUGGEST'" :item="i" :type="item.categoryScene" @toGetList="getListDataAgain"/>
										<!-- 其他普通类型 -->
										<articleCard v-else :item="i" :type="item.categoryScene" @getComment="getListDataAgain"/>	
									</div>
									<div v-if="loading" class="loading-text">加载中...</div>
									<div v-if="noMore" class="no-more-text">没有更多数据了</div>
								</div>
								<Empty content="该分类下无数据" v-show="dataList.length<1"/>
							</div>
						</el-tab-pane>
					</el-tabs>
				
					<!-- <Pagination :pageSize="pageSize" :pageNum="pageNum" :total="total" @pageChange="pageChange"/> -->

				</div>

			</div>
			<div class="aside">
				<asideNews/>
				<asideCircle/>
				<asideFollow/>
				<!-- <asideActive/> -->
			</div>
		</div>
	</div>
</template>

<script>
	import articleCard from '@/components/articleCard'
	import questions from '@/components/questions'
	import suggestion from '@/components/suggestion'
	import asideNews from '@/components/aside/news'
	import asideCircle from '@/components/aside/recommendCircle'
	import asideFollow from '@/components/aside/recommendFollow'
	import circleRecommend from './recommend'
	import circleNews from './recommendNews'
	import Pagination from '@/components/pagination'
	import Empty from '@/components/empty'
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'circleIndex',
		components: {
			articleCard,
			asideNews,
			asideCircle,
			asideFollow,
			circleRecommend,
			circleNews,
			Pagination,
			Empty,
			questions,
			suggestion
		},
		data(){
			return {
				activeTab: 'all',
				circleId: '',
				userId: '',
				circleModel: {},
				sortType: 1, //0最新互动 1最新 2热门
				sortFlag: 0, //0倒叙 1正序
				pageSize: 10,
				pageNum: 1,
				dataList: [],
				total: 0,
				navList: [],
				categoryId: '',
				topPost: [],
				options: [
					{
						value: 0,
						label: '新互动'
					}, 
					{
						value: 1,
						label: '最新'
					}, 
					{
						value: 2,
						label: '热门'
					}
				],
				value: 0,
				sortQuestion:1,
				suggestStatus: 1,
				optionsStatusJ: [
					{
						value: 1,
						label: '未处理'
					}, 
					{
						value: 2,
						label: '暂不处理'
					}, 
					{
						value: 3,
						label: '待优化'
					}, 
					{
						value: 4,
						label: '已解决'
					}, 
				],
				optionsStatusF: [
					{
						value: 1,
						label: '问题创建'
					}, 
					{
						value: 2,
						label: '已立项'
					}, 
					{
						value: 3,
						label: '开发中'
					}, 
					{
						value: 4,
						label: '已优化'
					}, 
				],
				feedbackStatus: 1,
				sysVersion: '',
				loading: false,
				tabHasHorizontalScroll: false,
			}
		},
		mounted() {
			this.checkTabScroll();
			window.addEventListener('resize', this.checkTabScroll);
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.checkTabScroll);
		},
		created(){
			this.userId = localStorage.getItem('userId')
			this.circleId = this.$route.query.id
			this.getDataCircle()
			this.getNavList()
			// this.getDataList()

			
		},
		watch:{
			$route(to) {
				this.circleId = to.query.id
				this.getDataCircle()
				this.getNavList()

			}
		},
		computed: {
			noMore() {
				return this.dataList.length >= this.total
			}
		},
		methods: {
			checkTabScroll() {
				this.$nextTick(() => {
					const navWrap = this.$el.querySelector('.el-icon-arrow-right');
					if (navWrap) {
						this.tabHasHorizontalScroll = true
					} else {
						this.tabHasHorizontalScroll = false
					}
				});
			},
			//获取圈子详情
			async getDataCircle(){
				let param = {
					circleId: this.circleId,
					userId: this.userId
				}
				ajaxParam(param)
				const res = await post('v1/circle/circleInfo', qs.stringify(param))
				if(res.data.code==200){
					this.circleModel = res.data.entity
					this.topPost = res.data.entity.topPost
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//获取帖子分类
			async getNavList(){
				let param = {
					circleId: this.circleId
				}
				ajaxParam(param)
				const res = await post('v1/circle/circlePostCategory', qs.stringify(param))
				if(res.data.code==200){
					this.navList = res.data.list
					if(this.$route.query.categoryId) {
						this.categoryId = this.$route.query.categoryId
						this.activeTab = this.categoryId
					}
					this.getDataList()
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//获取数据列表
			async getDataList(){
				if(this.noMore && this.total != 0 ) return
				this.loading = true
				let param = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					categoryId: this.categoryId,
					circleId: this.circleId,
					userId: this.userId,
					sortType: this.sortType,
					sortFlag: this.sortFlag,
					suggestStatus: this.suggestStatus,
					feedbackStatus: this.feedbackStatus,
					sysVersion: this.sysVersion
				}
				ajaxParam(param)
				const res = await post('v1/circle/postList', qs.stringify(param))
				if(res.data.code==200){
					this.dataList = this.pageNum==1 ? res.data.list : this.dataList.concat(res.data.list)
					if(!this.noMore){
						this.pageNum++
					}
					this.total = res.data.total
					this.loading = false
				} else {
					this.loading = false
					this.$message.error(res.data.msg)
				}
			},
			handleClick(tab) {
				this.suggestStatus = 1
				this.feedbackStatus = 1
				this.sysVersion = ''
				let name = tab.name
				if(tab.name == 'all') {
					this.categoryId = ''
				} else {
					this.categoryId = name
				}
				this.dataList = []
				this.pageNum = 1
				// 后台接口未定义回答、建议、反馈ID值，先写死
				if(this.value == 'QUESTION'){
					this.getAnswerList()
					return
				}
				this.getDataList()
				this.checkTabScroll(); // tab 切换后重新判断
			},
			pageChange(e){
				this.dataList = []
				this.pageNum = e.number
				this.getDataList()
			},
			toChangeSort(){
				this.sortType = this.value
				this.dataList = []
				this.pageNum = 1
				this.getDataList()
			},
			toChangeSortJ(){
				this.dataList = []
				this.pageNum = 1
				this.getDataList()
			},
			toChangeSortF(){
				this.dataList = []
				this.pageNum = 1
				this.getDataList()
			},
			toChangeSys(){
				this.dataList = []
				this.pageNum = 1
				this.getDataList()
			},
			focus(){
				this.activeTab = 'all'
				this.categoryId = ''
				this.getDataList()
			},
			toQuestionSort(e){
				this.sortType = e
				this.dataList = []
				this.pageNum = 1
				this.getDataList()
			},
			getListDataAgain(){
				this.tatal = 0
				this.dataList = []
				this.pageNum = 1
				this.getDataList()
			},
			// 查询回答列表接口
			async getAnswerList(){
				let param = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					postId: this.categoryId,
					circleId: this.circleId,
					userId: this.userId,
					sortType: this.sortType,
					sortFlag: this.sortFlag
				}
				ajaxParam(param)
				const res = await post('v1/circle/answerList', qs.stringify(param))
				if(res.data.code==200){
					this.dataList = res.data.list
					this.total = res.data.total
				} else {
					this.$message.error(res.data.msg)
				}
			},
		}
	}
</script>

<style scoped lang="less">
	.main{
		display: flex;
		justify-content: space-between;
		width: 1180px;
		max-width: 100%;
		margin: 20px auto;
		overflow: hidden;
		box-sizing: border-box;
		.content{
			flex: 1;
			width: 880px;
			max-width: 100%;
			overflow: hidden;
			box-sizing: border-box;
			// background: #fff;
			// padding: 40px;
			// border-radius: 10px;
		}
		.tabs{
			.lable-select{
				width: 80px;
				border: none;
				:deep .el-input__inner{
					border:none;
					background: #f2f2f2;
					color:#76767e;
					height: 100%;
				}
				:deep .el-input__suffix{
					right: -15px;
				}
				:deep .el-input--suffix .el-input__inner{
					padding-right: 0 !important;
				}
				:deep .el-select__caret{
					height:30px;
					line-height: 30px;
					color:#76767e;
				}
			}
		}
		.aside{
			width: 300px;
			margin-left: 20px;
		}
		.infinite-list {
			height: 100%;
			overflow: auto; /* 允许内容滚动 */
			scrollbar-width: none; /* Firefox */
			-ms-overflow-style: none; /* IE */
			padding: 0;
			margin: 0;
			list-style: none;
		}

		.infinite-list::-webkit-scrollbar {
			display: none; /* WebKit 浏览器 */
		}
		.loading-text,
		.no-more-text {
			text-align: center;
			color: #909399;
			padding: 12px;
			font-size: 14px;
		}

		.content-inner{
			position: relative;
			background: #fff;
			padding: 10px 40px 20px;
			border-radius: 10px;
			.sort-wrap{
				position: absolute;
				right: 40px;
				top: 10px;
				display: flex;
				align-items: center;
				// width: 198px;
				height: 32px;
				background: #F3F4F7;
				border-radius: 4px;
				justify-content: space-around;
				z-index: 999;
				span{
					display: block;
					width: 62px;
					height: 28px;
					border-radius: 4px;
					text-align: center;
					line-height: 28px;
					cursor: pointer;
					font-size: 12px;
				}
				span.active{
					background: #fff;
				}
			}
			.tabs :deep(.el-tabs__item.is-top:first-child) {
				padding-right: 0;
			}
			.tabs{
				:deep .el-tabs__item{
					height: 30px;
					line-height: 30px;
					background: #f2f2f2;
					color:#76767e;
					margin-right: 10px;
					border-radius: 6px;
					font-weight: 400;
				}
				:deep .el-tabs__item.is-top:last-child{
					padding-right: 20px;
				}
				/deep/ .el-tabs__item.is-top:first-child{
					padding-right: 0;
				}
				:deep .el-tabs__item.is-active{
					background-color:#e0e0e0;
					color: #40414f;
					.el-input__inner{
						background-color:#e0e0e0;
						color: #40414f;
						:deep .el-select__caret{
							color:#40414f;
							line-height: 30px;
							height: 30px;
						}
					}
				}
				:deep .el-tabs__item:hover{
					color: #40414f;
				}
				:deep .el-tabs__nav-wrap::after {
					display: none;  /* 去掉顶部灰色下边框 */
				}
				:deep .el-tabs__active-bar{
					background-color:transparent;
				}
				:deep .el-select>.el-input{
					display: flex;
				}
				:deep .el-input__suffix{
					top:-5px;
				}
				:deep .el-input__suffix{
					top:-5px;
				}
				:deep .info-select .el-input__suffix{
					top:0;
				}
			}
		}
		.questions-wrap-inner{
			width: 100%;
			display: flex;
			align-items: center;
			margin-bottom: 20px;
		}
		.suggestion-wrap{
			width: 100%;
			.lable-select{
				margin-right: 10px;
			}
		}
		.questions-wrap{
			display: flex;
			align-items: center;
			width: 198px;
			height: 30px;
			background: #c4c4c4;
			border-radius: 4px;
			justify-content: space-around;
			z-index: 20;
			color: #fff;
			span{
				display: block;
				width: 100%;
				height: 30px;
				border-radius: 4px;
				text-align: center;
				line-height: 32px;
				cursor: pointer;
				font-size: 12px;
			}
			span.active{
				background: #f04444;
			}
		}
	}
	.info-select{
		width:100px;
		height: 30px;
		line-height: 30px;
		border: none;
		border-radius: 6px;
		overflow: hidden;
		&.width-s{
			width: 72px;
		}
		:deep .el-input__inner{
			border:none;
			background: #f2f2f2;
			color:#76767e;
			height: 30px;
			line-height: 30px;
		}
		:deep .el-select__caret{
			height: 30px;
			line-height: 30px;
			color:#76767e;
		}
	}
	
	:deep .el-tabs__item:focus {
		outline: none !important;
		box-shadow: none !important;
	}
	:deep .el-tabs__nav-next{
		line-height: 32px;
	}
	:deep .el-tabs__nav-prev{
		line-height: 32px;
	}
	.loading-text,
	.no-more-text {
		text-align: center;
		color: #909399;
		padding: 12px;
		font-size: 14px;
	}
	.scroll-container {
		height: 800px;
		border-radius: 4px;
		padding: 20px;
	}
</style>
